var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHighAlert = function SvgHighAlert(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EAE9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6509 8.0866L6.63708 21.9286L6.63707 21.9286C6.19258 22.6963 5.97033 23.0802 6.00318 23.3953C6.03183 23.6701 6.17581 23.9198 6.39928 24.0823C6.65549 24.2686 7.09907 24.2686 7.98622 24.2686H24.0138C24.9009 24.2686 25.3445 24.2686 25.6007 24.0823C25.8242 23.9198 25.9682 23.6701 25.9968 23.3953C26.0297 23.0802 25.8074 22.6963 25.3629 21.9286L17.3491 8.08659C16.9062 7.32158 16.6848 6.93908 16.3959 6.81061C16.1439 6.69855 15.8561 6.69855 15.6041 6.81061C15.3152 6.93908 15.0938 7.32158 14.6509 8.0866ZM17 13.0638C17 12.5115 16.5523 12.0638 16 12.0638C15.4477 12.0638 15 12.5115 15 13.0638V16.9611C15 17.5134 15.4477 17.9611 16 17.9611C16.5523 17.9611 17 17.5134 17 16.9611V13.0638ZM16 19.8584C15.4477 19.8584 15 20.3062 15 20.8584C15 21.4107 15.4477 21.8584 16 21.8584H16.0097C16.562 21.8584 17.0097 21.4107 17.0097 20.8584C17.0097 20.3062 16.562 19.8584 16.0097 19.8584H16Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHighAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "highAlert.4c30a254963695971352db5edb6490d2.svg";